
























import { Type, OptionalType, Exprs } from 'expangine-runtime';
import { TypeUpdateEvent } from '../TypeVisuals';
import { OptionalSubs, OptionalOptions } from './OptionalTypes';
import TypeEditorBase from '../TypeEditorBase';


export default TypeEditorBase<OptionalType, OptionalOptions, OptionalSubs>().extend({
  name: 'OptionalEditor',
  computed: {
    requiredInner(): Type | null {
      return this.requiredType && this.requiredType instanceof OptionalType
        ? this.requiredType.options
        : null;
    },
  },
  methods: {
    onChange(event: TypeUpdateEvent) {
      const previousType = this.type.options;
      
      const transform = event.transform
        ? this.type.getValueChangeExpression(event.transform, OptionalType.STEP_OPTIONAL, OptionalType.STEP_OPTIONAL)
        : undefined;

      this.type.options = event.type;
      this.settings.sub.innerType = event.settings;

      this.change({ transform });
    },
  },
});
